export default __webpack_public_path__ + "static/media/ZTICMA.4e4d8884.png";